import React from 'react';
import { connect } from 'react-redux';

import AudioStockItemCard from '../../app/Search/components/card/AudioStockItemCard';
import { StockItemArtistInterface } from '../../app/Search/containers/MenuContainerInterfaces';
import { ContentClass } from '../../app/Shared/enums';
import {
  selectHasAudioSubscription,
  selectHasImagesSubscription,
  selectHasVideoSubscription,
} from '../../auth/AuthSelectors';
import { StockItemContext } from '../../common/types/StockItemTypes';
import AssetId, { getLabel } from '../components/AssetId';
import MediaPreviewWithInfo from '../components/MediaPreviewWithInfo';
import ReportErrorModal from '../components/ReportErrorModal';
import StockItemCategoryLinks from '../components/StockItemCategoryLinks';
import StockItemInfo from '../components/StockItemInfo';
import StockItemKeyWordLinks from '../components/StockItemKeyWordLinks';
import FormatSelector from '../components/download/FormatSelector';
import {
  selectDetailsStockItemArtists,
  selectDetailsStockItemFormats,
} from '../selectors/detailsSelectors';
import AbstractItemDetailsContainer, {
  AbstractItemDetailsContainerProps,
  commonStateToProps,
} from './AbstractItemDetailsContainer';

import './stock-item-details.less';

interface Props extends AbstractItemDetailsContainerProps {
  stockItemArtists: StockItemArtistInterface[];
}

class AudioDetailsContainer extends AbstractItemDetailsContainer<Props> {
  render() {
    const {
      stockItem: { contentType, contentClass, detailsUrl, assetId },
    } = this.props;

    return (
      <div id="details-app-container">
        <div className="stockItemDetails">
          <div className="container-fluid">
            <div className="stockItemDetails-row">
              <div className="stockItemDetails-section">
                <MediaPreviewWithInfo>
                  <AudioStockItemCard
                    stockItem={this.props.stockItem}
                    stockItemFormats={this.props.stockItemFormats}
                    stockItemArtists={this.props.stockItemArtists}
                    shouldShowDownloadButton={false}
                    shouldShowAddToFavorites={false}
                    context={StockItemContext.DETAILS_PLAYER}
                  />
                  <StockItemInfo expanded />
                </MediaPreviewWithInfo>
                <hr className="stockItemDetails-divider" />
                <ReportErrorModal stockItemId={this.props.stockItem.id} />
              </div>
              <div className="stockItemDetails-section">
                <div className="downloadOptions-row">
                  {this.buildMemberLibraryMessaging(
                    'royalty free music, sound effects'
                  )}
                  <AssetId assetId={assetId} label={getLabel(contentType)} />
                  <FormatSelector />
                  {this.buildDownloadCta(
                    'Music and Sound Effects',
                    ContentClass.Audio
                  )}
                </div>
              </div>
            </div>
            <div className="gray-row">
              <div className="gray-section similar">
                {this.renderSimilarStockItems({
                  contentType,
                  contentClass,
                  detailsUrl,
                })}
              </div>
              <div className="gray-section categoriesAndKeywords">
                <div>{this.getCategoriesAndKeywords()}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  upgradeRequiredForMember() {
    return (
      this.props.stockItem.type === 'sfx' && !this.props.downloadPermissions.sfx
    );
  }

  getCategoriesAndKeywords() {
    const { categories, keywords, moods, genres, instruments } =
      this.props.stockItem;

    return (
      <div className="stockItemDetails-stockItemSeoLinksContainer">
        <StockItemKeyWordLinks title="Keywords" keywords={keywords} />
        <StockItemCategoryLinks title="Categories" categories={categories} />
        <StockItemCategoryLinks title="Moods" categories={moods} />
        <StockItemCategoryLinks title="Genres" categories={genres} />
        <StockItemCategoryLinks title="Instruments" categories={instruments} />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    ...commonStateToProps(state),
    stockItemFormats: selectDetailsStockItemFormats(state),
    stockItemArtists: selectDetailsStockItemArtists(state),
    hasSubscription: selectHasAudioSubscription(state) !== null,
    hasOtherSubscriptions: Boolean(
      selectHasVideoSubscription(state) || selectHasImagesSubscription(state)
    ),
    siteSubscription: selectHasAudioSubscription(state),
  };
}

// @ts-expect-error This is complicated. There is documentation at https://react-redux.js.org/using-react-redux/usage-with-typescript#typing-the-connect-higher-order-component
export default connect(mapStateToProps)(AudioDetailsContainer);
